<template>
  <canvas ref="scene" :style="canvasStyle" touch-action="none"></canvas>
</template>

<script>
import {Engine, Scene, ArcRotateCamera, MeshBuilder, StandardMaterial, Texture, Color3} from 'babylonjs'
import 'pepjs'

export default {
  props: ['texturePath', 'quality'],
  computed: {
    canvasStyle () {
      return {
        // height: `${this.$window.innerHeight}px`
      }
    }
  },
  mounted () {
    // const name = this.getQueryVariable('name')
    // const quality = parseFloat(this.getQueryVariable('quality')) || 0.8
    // const texturePath = `https://www.straitstimes.com/multimedia/graphics/assets/widget-assets/360-image-widget/${name}.jpg`

    console.log('path', this.texturePath)
    console.log('360 quality', this.quality)

    const canvas = this.$refs.scene
    const engine = new Engine(canvas, true)
    engine.setHardwareScalingLevel(this.quality)
    const scene = new Scene(engine)
    // scene.clearColor = Color3(0, 0, 0)
    scene.autoClear = false
    scene.autoClearDepthAndStencil = false

    const camera = new ArcRotateCamera('camera1', 0, Math.PI / 2, 1, null, scene)
    camera.inputs.remove(camera.inputs.attached.keyboard)
    camera.inputs.remove(camera.inputs.attached.mousewheel)
    camera.lowerRadiusLimit = 1
    camera.upperRadiusLimit = 1
    camera.fov = 1.5
    camera.attachControl(canvas)
    const skyDome = MeshBuilder.CreateSphere('skydome', {segments: 32, diameter: 100}, scene)
    skyDome.rotation.x = Math.PI
    skyDome.freezeWorldMatrix()
    skyDome.convertToUnIndexedMesh()

    skyDome.material = new StandardMaterial('skydomeMat', scene)

    skyDome.material.emissiveTexture = new Texture(this.texturePath, scene)
    skyDome.material.backFaceCulling = false
    skyDome.material.freeze()

    scene.blockMaterialDirtyMechanism = true

    scene.executeWhenReady(() => {
      engine.resize()
      engine.runRenderLoop(() => {
        scene.render()
      })
    })

    window.addEventListener('resize', () => {
      engine.resize()
      scene.render()
    })
  },
  // methods: {
  //   getQueryVariable (variable) {
  //     var query = window.location.search.substring(1)
  //     var vars = query.split('&')
  //     for (var i = 0; i < vars.length; i++) {
  //       var pair = vars[i].split('=')
  //       if (pair[0] === variable) return pair[1]
  //     }
  //     return false
  //   }
  // }
}
</script>

<style lang="scss" scoped>
canvas {
  display: block;
  width: 100%;
  background-color: #000000;
}
</style>
